import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
} from "@chakra-ui/react";
import Spinner from "components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { putApi } from "services/api";
import { getApi } from "services/api";
import { generateValidationSchema } from "../../../utils";
import CustomForm from "../../../utils/customForm";
import { ToastContainer, toast } from "react-toastify";
import { FcCancel } from "react-icons/fc";
import * as yup from "yup";

const Edit = (props) => {
  const { data } = props;
  const [isLoding, setIsLoding] = useState(false);
  const initialFieldValues = Object.fromEntries(
    (props?.leadData?.fields || []).map((field) => [field?.name, ""])
  );

  const [initialValues, setInitialValues] = useState({
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  });
  const param = useParams();

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.leadData?.fields)),
    onSubmit: (values, { resetForm }) => {
      EditData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

//   const EditData = async () => {

//     //console.log(values?.leadRemark, "..............................values");
//     //console.log(Array.isArray(values.comments))
//     // Ensure leadRemark exists
//     let selectedRemark = values?.leadRemark || "pending"; // Default to "pending" if undefined
//     let selectedStatus = "";

//     // Determine lead status based on leadRemark
//     switch (selectedRemark) {
//       case "rnr":
//       case "notInterested":
//       case "busy":
//       case "notReachable":
//       case "currentlyNotInterested":
//       case "leadLost":
//         selectedStatus = "cold";
//         break;

//       case "followUp":
//       case "visitScheduled":
//       case "visitReschedule":
//       case "videoCallScheduled":
//       case "videoCallReschedule":
//         selectedStatus = "warm";
//         break;

//       case "OfficeVisitSchedule":
//       case "OfficeVisitReschedule":
//       case "visitedDone":
//       case "bookingDone":
//         selectedStatus = "hot"; // Return 'hot' status
//         break;
//       case "salesClosed":
//       case "alreadyPurchased":
//         selectedStatus = "booked";
//         break;

//       default:
//         selectedStatus = "pending";
//         break;
//     }

//     try {
//       setIsLoding(true); // Set loading state before API call


//       let commentsArray = Array.isArray(values.comments)
//     ? values.comments
//     : [{ 
//         comment: values.comments, 
//         createdAt: new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) 
//     }];

// let payload = {
//     ...values,
//     comments: commentsArray, // Ensure comments are in array format
//     leadStatus: selectedStatus,
//     moduleId: props?.moduleId || null, // Ensure it's set
// };
// //console.log(payload)
//       let response = await putApi(
//         `api/form/edit/${props?.selectedId || param.id}`,
//         payload
//       );

//       if (response?.status === 200) {
//         //console.log("Update Successful", response.data);
//         props.onClose();
//         props.setAction((prev) => !prev);
//       } else {
//         console.error("Failed to update lead:", response);
//       }
//     } catch (error) {
//       console.error("Error in EditData:", error);
//     } finally {
//       setIsLoding(false); // Always reset loading state
//     }
//   };
const EditData = async () => {
  //console.log("Values",values)
  //console.log(values?.leadRemark, "Lead Remark Selected");
  //console.log("DateTime Value:", values?.dateTime); // Debugging

  let selectedRemark = values?.leadRemark || "pending"; // Default to "pending" if undefined
  let selectedStatus = "";

  switch (selectedRemark) {
      case "rnr":
      case "notInterested":
      case "busy":
      case "notReachable":
      case "currentlyNotInterested":
      case "leadLost":
          selectedStatus = "cold";
          break;

      case "followUp":
      case "visitScheduled":
      case "visitReschedule":
      case "videoCallScheduled":
      case "videoCallReschedule":
          selectedStatus = "warm";
          break;

      case "OfficeVisitSchedule":
      case "OfficeVisitReschedule":
      case "visitedDone":
      case "bookingDone":
          selectedStatus = "hot";
          break;

      case "salesClosed":
      case "alreadyPurchased":
          selectedStatus = "booked";
          break;

      default:
          selectedStatus = "pending";
          break;
  }

  
  try {
      setIsLoding(true);

      //console.log("Values",values)
      //console.log(values?.leadRemark, "Lead Remark Selected");
      //console.log("DateTime Value:", values?.dateTime);

      const requiredDateTimeRemarks = [
      "followUp",
      "visitScheduled",
      "visitReschedule",
      "videoCallScheduled",
      "videoCallReschedule",
      "OfficeVisitSchedule",
      "OfficeVisitReschedule",
  ];

  // **Improved DateTime Validation**
  if (requiredDateTimeRemarks.includes(selectedRemark) && (!values?.dateTime || !values.dateTime.trim())) {
      toast.error("Date and Time are required for this status.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          icon: <FcCancel />,
          style: {
              backgroundColor: "#fffff",
              color: "red",
              fontSize: "16px",
              borderRadius: "8px",
          },
      });
      return;
  }


      let commentsArray = Array.isArray(values.comments)
          ? [...values.comments, { 
              comment: values.newComment, 
              createdAt: values.newComment ? new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) : undefined
          }]
          : [{ 
              comment: values.comments, 
              createdAt: values.comments ? new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) : undefined
          }];

      let payload = {
          ...values,
          comments: commentsArray,
          leadStatus: selectedStatus,
          moduleId: props?.moduleId || null,
          isEdited:(values.isEdited || 0)+1,
      };

      //console.log("Payload Sent to API:", payload);

      let response = await putApi(
          `api/form/edit/${props?.selectedId || param.id}`,
          payload
      );

      if (response?.status === 200) {
          //console.log("Update Successful", response.data);
          props.onClose();
          props.setAction((prev) => !prev);
          toast.success("Lead Updated successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              icon: "✅",
              style: {
                  backgroundColor: "#fffff",
                  color: "green",
                  fontSize: "16px",
                  borderRadius: "8px",
              },
          });
      } else {
          console.error("Failed to update lead:", response);
          toast.error("Failed to update lead:", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              icon: <FcCancel/>,
              style: {
                  backgroundColor: "#fffff",
                  color: "red",
                  fontSize: "16px",
                  borderRadius: "8px",
              },
          });
      }
  } catch (error) {
      console.error("Error in EditData:", error);
  } finally {
      setIsLoding(false);
  }
};



  const handleClose = () => {
    props.onClose(false);
    props.setSelectedId && props?.setSelectedId();
    formik.resetForm();
  };

  let response;
  const fetchData = async () => {
    if (data) {
      setInitialValues((prev) => ({ ...prev, ...data }));
    } else if (props?.selectedId) {
      // } else if (props?.selectedId || param.id) {
      try {
        setIsLoding(true);
        response = await getApi("api/lead/view/", props?.selectedId);
        let editData = response?.data?.lead;
        setInitialValues((prev) => ({ ...prev, ...editData }));
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoding(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [props?.selectedId, data]);

  return (
    <div>
      <Drawer isOpen={props.isOpen} size={props.size}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
            alignItems={"center"}
            justifyContent="space-between"
            display="flex"
          >
            Edit Lead
            <IconButton onClick={handleClose} icon={<CloseIcon />} />
          </DrawerHeader>
          <DrawerBody>
            {isLoding ? (
              <Flex
                justifyContent={"center"}
                alignItems={"center"}
                width="100%"
              >
                <Spinner />
              </Flex>
            ) : (
              <CustomForm
                moduleData={props.leadData}
                values={values}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
              />
            )}
          </DrawerBody>

          <DrawerFooter>
            <Button
              sx={{ textTransform: "capitalize" }}
              variant="brand"
              size="sm"
              type="submit"
              disabled={isLoding ? true : false}
              onClick={handleSubmit}
            >
              {isLoding ? <Spinner /> : "Update"}
            </Button>
            <Button
              variant="outline"
              colorScheme="red"
              size="sm"
              sx={{
                marginLeft: 2,
                textTransform: "capitalize",
              }}
              onClick={handleClose}
            >
              Close
            </Button>
          </DrawerFooter>
        </DrawerContent>
        <ToastContainer />
      </Drawer>
    </div>
  );
};

export default Edit;
